import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { resourcesApi, ResourceBudget } from '@/services/api/agentApi';
import * as errorUtils from '@/utils/errors';

interface ResourcesStoreState {
  budget: ResourceBudget | null;
  summary: any | null;
  usageLogs: any[];
  tierBreakdown: any[];
  isLoading: boolean;
  error: string | null;
}

interface ResourcesStoreActions {
  fetchBudget: () => Promise<void>;
  fetchSummary: () => Promise<void>;
  fetchUsageLogs: (params?: Record<string, string>) => Promise<void>;
  fetchTierBreakdown: () => Promise<void>;
}

export const useResourcesStore = create<ResourcesStoreState & ResourcesStoreActions>()(
  immer((set) => ({
    budget: null,
    summary: null,
    usageLogs: [],
    tierBreakdown: [],
    isLoading: false,
    error: null,

    fetchBudget: async () => {
      try {
        const result = await resourcesApi.getCurrentBudget();
        set((s) => { s.budget = result.data; });
      } catch (error: unknown) {
        set((s) => { s.error = errorUtils.getErrorMessage(error); });
      }
    },

    fetchSummary: async () => {
      set((s) => { s.isLoading = true; });
      try {
        const result = await resourcesApi.getSummary();
        set((s) => { s.summary = result.data; s.isLoading = false; });
      } catch (error: unknown) {
        set((s) => { s.error = errorUtils.getErrorMessage(error); s.isLoading = false; });
      }
    },

    fetchUsageLogs: async (params) => {
      try {
        const result = await resourcesApi.getUsage(params);
        set((s) => { s.usageLogs = result.data; });
      } catch (error: unknown) {
        set((s) => { s.error = errorUtils.getErrorMessage(error); });
      }
    },

    fetchTierBreakdown: async () => {
      try {
        const result = await resourcesApi.getUsageByTier();
        set((s) => { s.tierBreakdown = result.data; });
      } catch (error: unknown) {
        set((s) => { s.error = errorUtils.getErrorMessage(error); });
      }
    },
  }))
);
